import React from "react";
import PandaLoader from "../PandaLoader";
import { getGenerationEstimate } from "../../utils/audiobookEstimate";

const FREDOKA = { fontFamily: "'Fredoka', sans-serif" };

const AudiobookProgressBar = ({ progress = 0, pageCount }) => {
  const estimate = getGenerationEstimate(pageCount);
  return (
    <div
      className="p-8"
      style={{
        background: '#FFFFFF',
        border: '2px solid rgba(11,26,51,0.06)',
        borderRadius: 22,
        boxShadow: '0px 2px 0px rgba(11,26,51,0.04), 0px 8px 20px rgba(11,26,51,0.06)',
      }}
    >
      <div className="flex flex-col items-center text-center" style={{ gap: 16 }}>
        <PandaLoader variant="inline" size={180} />

        <div style={{ marginTop: 4 }}>
          <h3 className="text-2xl mb-1" style={{ ...FREDOKA, color: '#0B1A33', fontWeight: 700 }}>
            Creating Your Audiobook...
          </h3>
          <p className="text-lg" style={{ ...FREDOKA, color: '#0065F8', fontWeight: 600 }}>
            {progress}% Complete
          </p>
        </div>

        {/* Progress Bar */}
        <div className="w-full max-w-md">
          <div className="h-2.5 rounded-full overflow-hidden" style={{ background: 'rgba(11,26,51,0.08)' }}>
            <div
              className="h-full rounded-full transition-all duration-500 ease-out"
              style={{
                width: `${progress}%`,
                background: 'linear-gradient(90deg, #0065F8 0%, #00CAFF 100%)',
              }}
            />
          </div>
        </div>

        <p className="text-sm max-w-md" style={{ ...FREDOKA, color: '#5A6B85', lineHeight: 1.5 }}>
          Your audiobook is being generated. This usually takes {estimate}.
          You can stay on this page and watch the progress update in real-time!
        </p>
      </div>
    </div>
  );
};

export default AudiobookProgressBar;
